import { Image, Label, Panel } from "@mcleod/components";

export class StopUtil {
    public static setupOriginLateStatusPanel(statusPanel: Panel, statusLabel: Label, lateStatus: string | null, bgColor: string) {
        const hasLateStatus = lateStatus != null;
        const imageBrokerageStatus = statusPanel?.findComponentById("imageNextStopLateStatusChevron") as Image;
        if (statusPanel != null) {
            statusPanel.visible = hasLateStatus;
            if (hasLateStatus) {
                if (bgColor === "#ffffff") {
                    statusPanel.borderWidth = 1;
                    statusPanel.borderColor = "primary";
                    statusPanel.backgroundColor = bgColor;
                    if (statusLabel) {
                        statusLabel.color = "primary";
                    }
                    if (imageBrokerageStatus) {
                        imageBrokerageStatus.color = "primary";
                    }
                } else {
                    statusPanel.borderWidth = 0;
                    statusPanel.backgroundColor = bgColor;
                    if (statusLabel) {
                        statusLabel.color = "default.reverse";
                    }
                    if (imageBrokerageStatus) {
                        imageBrokerageStatus.color = "default.reverse";
                    }
                }
                if (statusLabel) {
                    statusLabel.text = lateStatus || "--";
                }
            }
        }
    }
}
